
import { useState, useEffect } from "react";
import calendarStyles from "pages/landingpage/calendar/CalendarSection.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./BookingManagementTimeTable.module.css";
import CustomerBookingPopup from "../customerBookinkPooup/customerBookingPopup";
import { WorkTimeSlot, HolidaySlot } from "modules/calendar-worktime-holiday";
import { fetchWorkSlots, fetchHolidaySlots } from "services/workTime/calendar-service";
import { getParentKids } from "services/get-parents-kids";
import { Booking } from "modules/booking";
import { getMonday, getWeekdayLetter, isSameDate, uniqueTimeSlots, updateWeeks } from "utils/calender";
import CalendarControler from "components/calender/calenderController";
import CalenderBottons from "components/calender/calenderBottons";
import React from "react";
import { getParentsKidBooking } from "services/booking/get-parents-kid-bookings";
import { KidsData } from "modules/profile";
import CustomerCancelPopup from "../customerBookinkPooup/costumerCancelPopup";
import { getSlotBookingDateCounter } from "services/booking/get-slot-booking-date-counter";

export default function BookingManagementTimeTable() {
    const [workTimeSlots, setWorkTimeSlots] = useState<WorkTimeSlot[]>([]);
    const [holidaySlots, setHolidaySlots] = useState<HolidaySlot[]>([]);
    const [kidsData, setKidsData] = useState<KidsData[]>([]);
    const [bookingsData, setBookingsData] = useState<Booking[]>([]);
    const [weekOffset, setWeekOffset] = useState(0);
    const [week, setWeek] = useState<Date[]>([]);
    const [selectedKid, setSelectedKid] = useState('');
    const currentTime = new Date();
    const times = uniqueTimeSlots(workTimeSlots, week);
    const [bookingData, setBookingData] = useState<any>({});
    const [isBookingPopupOpen, setIsBookingPopupOpen] = useState(false);
    const handleOpenBookingPopup = () => setIsBookingPopupOpen(true);
    const handleCloseBookingPopup = () => { fetchData(); setIsBookingPopupOpen(false); }
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
    const handleOpenCancelPopup = () => setIsCancelPopupOpen(true);
    const handleCloseCancelPopup = () => { fetchData(); setIsCancelPopupOpen(false); }



    const fetchData = async () => {
        try {
            const workData = await fetchWorkSlots();
            const holidayData = await fetchHolidaySlots();
            const kidsDataRes = await getParentKids();
            setKidsData(kidsDataRes.kids);
            setWorkTimeSlots(workData);
            setHolidaySlots(holidayData);

            if (kidsDataRes.kids && kidsDataRes.kids.length > 0) {
                setSelectedKid(kidsDataRes.kids[0].id.toString());
                const kidIds = kidsDataRes.kids.map((kid: KidsData) => kid.id);
                if (kidIds.length > 0) {
                    const monday = getMonday(new Date());
                    const kidsBookingsData = await getParentsKidBooking(kidIds, monday);

                    const formattedBookingsData = kidsBookingsData.Kids_bookings_data.map((booking: any) => ({
                        ...booking,
                        date: new Date(booking.date),
                        recurrence_date_0: booking.recurrence_date_0 ? new Date(booking.recurrence_date_0) : null,
                        recurrence_date_1: booking.recurrence_date_1 ? new Date(booking.recurrence_date_1) : null,
                        recurrence_date_2: booking.recurrence_date_2 ? new Date(booking.recurrence_date_2) : null,
                        recurrence_date_3: booking.recurrence_date_3 ? new Date(booking.recurrence_date_3) : null,
                    }));
                    setBookingsData(formattedBookingsData);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchBookingCounter = async () => {
        try {
            if (week.length > 1) {
                const startDate = week[0];
                const endDate = week[week.length - 1];
                const result = await getSlotBookingDateCounter(startDate, endDate);
                setBookingData(result.data);
            } else {
                console.error("Das Wochen-Array ist nicht richtig initialisiert.");
            }
        } catch (error) {
            console.error("Fehler beim Abrufen der Buchungenszähler:", error);
        }
    };
    useEffect(() => {
        if (week && week.length > 1) {
            fetchBookingCounter();
        }
    }, [week]);

    useEffect(() => {
        fetchData();
        setWeek(updateWeeks(0, 4))
    }, []);



    const handleCurrentWeek = () => {
        setWeekOffset(0);
        setWeek(updateWeeks(0, 4))
    };

    const handleNextWeek = () => {
        setWeekOffset((prevOffset) => {
            const newOffset = prevOffset + 4;
            setWeek(updateWeeks(newOffset, 4))
            return newOffset;
        });
    };

    const handlePreviousWeek = () => {
        setWeekOffset((prevOffset) => {
            const newOffset = prevOffset - 4;
            setWeek(updateWeeks(newOffset, 4))
            return newOffset;
        });
    };


    return (
        <div className={calendarStyles.container}>
            <div className={styles.CalendarPanel}>
                <div className={styles.CalendarController}>
                    <CalendarControler
                        currentDate={currentTime}
                        week={week}
                        weekOffset={weekOffset}
                        onCurrentWeek={handleCurrentWeek}
                        onPreviousWeek={handlePreviousWeek}
                        onNextWeek={handleNextWeek}
                        showPrevious={true} />
                </div>
                <div className={styles.radioContainer}>
                    {kidsData.length <= 3 ? (
                        kidsData.map((kid) => (
                            <label key={kid.id}>
                                <input
                                    type="radio"
                                    name="child"
                                    value={kid.id}
                                    checked={selectedKid === kid.id.toString()}
                                    onChange={() => setSelectedKid(kid.id.toString())} />
                                {kid.first_name} {kid.last_name}
                            </label>
                        ))
                    ) : (
                        <select
                            className={commonStyles.Select}
                            value={selectedKid}
                            onChange={(e) => setSelectedKid(e.target.value)}>
                            {kidsData.map((kid) => (
                                <option key={kid.id} value={kid.id}>
                                    {kid.first_name} {kid.last_name}
                                </option>
                            ))}
                        </select>
                    )}
                </div>
                <CalenderBottons handleOpenBookingPopup={handleOpenBookingPopup} handleOpenCancelPopup={handleOpenCancelPopup} />
                <CustomerBookingPopup isOpen={isBookingPopupOpen} onClose={handleCloseBookingPopup} />
                <CustomerCancelPopup isOpen={isCancelPopupOpen} onClose={handleCloseCancelPopup} />
            </div>
            <table className={calendarStyles.table}>
                <thead>
                    <tr>
                        <th>Uhrzeit</th>
                        {week.slice(0, 5).map((day, index) => (
                            <th key={index}>{getWeekdayLetter(day).slice(0, 2)}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {[[0, 5], [5, 10], [10, 15], [15, 20]].map((weekRange, weekIndex) => (
                        <React.Fragment key={`week-${weekIndex}`}>
                            <tr className={calendarStyles.kalenderDatum}>
                                <td className={calendarStyles.kalenderUhrzeit}></td>
                                {week.slice(weekRange[0], weekRange[1]).map((day, index) => (
                                    <td key={index} className={day < new Date() ? calendarStyles.past : ""}>
                                        <div className={isSameDate(day, currentTime)
                                            ? calendarStyles.currentDay
                                            : ""}>
                                            {day.getDate().toString().padStart(2, '0')}
                                        </div>
                                    </td>
                                ))}
                            </tr>

                            {times.map((time, index) => (
                                <tr key={`${index}-week${weekIndex + 1}`}>
                                    <td className={calendarStyles.kalenderUhrzeit}>{time}</td>
                                    {week.slice(weekRange[0], weekRange[1]).map((day, dayIndex) => {
                                        const slot = workTimeSlots.find((slot) =>
                                            slot.day_of_week === getWeekdayLetter(day) &&
                                            slot.start_time.substring(0, 5) === time.split(" - ")[0] &&
                                            slot.end_time.substring(0, 5) === time.split(" - ")[1]
                                        );
                                        const holidaysInDay = holidaySlots.filter((holidaySlot) => {
                                            const holidayDate = new Date(holidaySlot.date);
                                            return isSameDate(day, holidayDate);
                                        });

                                        const isFullClosed = holidaysInDay.some(holiday => holiday.is_full_day) ||
                                            holidaysInDay.length === workTimeSlots.filter((slot) => {
                                                return slot.day_of_week === getWeekdayLetter(day);
                                            }).length
                                        if (isFullClosed) {
                                            return index === 0 ? (
                                                <td key={dayIndex} rowSpan={times.length} className={`${calendarStyles.geschlossen} ${calendarStyles.past}`}>
                                                    <center>
                                                        <span className={styles.geschlossen}>geschlossen</span>
                                                    </center>
                                                </td>
                                            ) : (null);
                                        } else {
                                            const placesCount = slot ? Number(slot.number_of_places) : 0;
                                            const [startHour, startMinute] = time.split(" - ")[0].split(":").map(Number);
                                            const startTime = new Date(day);
                                            startTime.setHours(startHour, startMinute, 0);
                                            const isPastDate = currentTime > startTime;
                                            const isClosed = !slot || holidaysInDay.some(holiday => holiday.block === slot.id);
                                            const isBooked = bookingsData.some(booking => {
                                                const bookingDate = new Date(booking.date);

                                                return (
                                                    booking.work_time_slot_id == slot?.id &&
                                                    booking.kid_id.toString() === selectedKid &&
                                                    ((bookingDate.toDateString() === day.toDateString() && booking.recurrence === "onetime") ||
                                                        (booking.recurrence === "serial" &&
                                                            (booking.recurrence_date_0?.toDateString() === day.toDateString() ||
                                                                booking.recurrence_date_1?.toDateString() === day.toDateString() ||
                                                                booking.recurrence_date_2?.toDateString() === day.toDateString() ||
                                                                booking.recurrence_date_3?.toDateString() === day.toDateString())))
                                                );
                                            });

                                            const dateStr = day.toISOString().split('T')[0];
                                            const bookingsForDate = bookingData[dateStr] || [];
                                            const confirmedBookings = bookingsForDate.find(
                                                (booking: any) => booking.work_time_slot_id.toString() === slot?.id
                                            );
                                            const bookedPlaces = confirmedBookings ? confirmedBookings.confirmed_bookings_count : 0;
                                            const placesLeft = (placesCount - bookedPlaces) > 0 ? placesCount - bookedPlaces : 0;
                                            return (
                                                <td key={dayIndex} className={isPastDate || placesLeft === 0 || isClosed ? calendarStyles.past : ""}>
                                                    <div>
                                                        {isClosed ? (
                                                            <span className={calendarStyles.geschlossen}>geschlossen</span>
                                                        ) : (
                                                            <>
                                                                <div className={`${calendarStyles.platzContainer} ${isBooked ? styles.booked : ""}`}>
                                                                    <span className={isPastDate || placesLeft === 0 || isClosed ? calendarStyles.platzNumbedisble : calendarStyles.platzNumber}>
                                                                        {placesLeft}
                                                                    </span>
                                                                    <span className={calendarStyles.platzLebel}>Plätze</span>
                                                                </div>

                                                            </>
                                                        )
                                                        }
                                                    </div>
                                                </td>
                                            );
                                        }


                                    })}
                                </tr>
                            ))}
                        </React.Fragment>))}
                </tbody>
            </table>
        </div>
    );
}
